import { slideToggle, slideUp, slideDown, toggleAria } from "../utils.js";
import "core-js/es/array";

class Accordion {
  constructor(selector, threshold = 300) {
    this.accordionHeads = Array.from(document.querySelectorAll(selector));
    this.threshold = threshold;
    if (this.accordionHeads.length > 0) {
      this.initAccordion();
    }
  }

  isCloseToBottom(element) {
    const rect = element.getBoundingClientRect();
    return window.innerHeight - rect.bottom <= this.threshold;
  }

  handleAccordionClick(event) {
    const link = event.currentTarget;

    if (link.classList.contains("no-click")) return;

    // Close all other accordion items
    this.accordionHeads.forEach((otherLink) => {
      if (otherLink !== link && otherLink.classList.contains("active")) {
        const otherTextEl = otherLink.querySelector(
          ".c-accordion__header-text"
        );

        if (otherTextEl) {
          otherTextEl.innerHTML = otherTextEl.dataset.closed;
        }

        otherLink.classList.remove("active");

        toggleAria(otherLink, "aria-expanded");
        if (
          !otherLink
            .closest(".c-accordion")
            .classList.contains("c-accordion--alt")
        ) {
          slideUp(otherLink.nextElementSibling, 200);
        } else {
          // Remove the class if it was added for being close to the bottom
          otherLink.classList.remove("close-to-bottom");
          // Check if the link is close to the bottom and add the specific class
          if (this.isCloseToBottom(otherLink)) {
            otherLink.classList.add("close-to-bottom");
          }
        }
      }
    });

    const textEl = link.querySelector(".c-accordion__header-text");

    if (textEl) {
      if (!link.classList.contains("active")) {
        textEl.innerHTML = textEl.dataset.open;
      } else {
        textEl.innerHTML = textEl.dataset.closed;
      }
    }

    if (!link.closest(".c-accordion").classList.contains("c-accordion--alt")) {
      slideToggle(link.nextElementSibling, 200);
    } else {
      // Remove the class if it was added for being close to the bottom
      link.classList.remove("close-to-bottom");
      // Check if the link is close to the bottom and add the specific class
      if (this.isCloseToBottom(link)) {
        link.classList.add("close-to-bottom");
      }
    }
    link.classList.add("no-click");
    link.classList.toggle("active");

    toggleAria(link, "aria-expanded");

    setTimeout(() => {
      link.classList.remove("no-click");
    }, 250);
  }

  initAccordion() {
    this.accordionHeads.forEach((link) => {
      link.addEventListener("click", this.handleAccordionClick.bind(this));
    });
  }
}

export default Accordion;

